/*
 * App Actions
 *
 * Actions change things in your application
 * Since this boilerplate uses a uni-directional data flow, specifically redux,
 * we have these actions which are the only way your application interacts with
 * your appliction state. This guarantees that your state is up to date and nobody
 * messes it up weirdly somewhere.
 *
 * To add a new Action:
 * 1) Import your constant
 * 2) Add a function like this:
 *    export function yourAction(var) {
 *        return { type: YOUR_ACTION_CONSTANT, var: var }
 *    }
 */

export const GET_TOKEN = 'VNT/App/GET_TOKEN';
export const GET_TOKEN_SUCCESS = 'VNT/App/GET_TOKEN_SUCCESS';
export const GET_TOKEN_ERROR = 'VNT/App/GET_TOKEN_ERROR';
export const INVALID_ACCESS = 'VNT/App/INVALID_ACCESS';
export const GET_PROFILE = 'VNT/App/GET_PROFILE';
export const GET_PROFILE_SUCCESS = 'VNT/App/GET_PROFILE_SUCCESS';
export const GET_PROFILE_ERROR = 'VNT/App/GET_PROFILE_ERROR';
export const GET_REFRESHED_TOKEN_SUCCESS = 'VNT/App/GET_REFRESHED_TOKEN_SUCCESS'; 
export const LOG_OUT = 'VNT/App/LOG_OUT';
export const LOGIN = 'VNT/App/LOGIN';
export const LOADING = 'VNT/App/LOADING';
export const LOGIN_SUCCESS = 'VNT/App/LOGIN_SUCCESS';
export const API_INFO_SUCCESS = 'VNT/App/API_INFO_SUCCESS';
export const LOGIN_FAILED = 'VNT/App/LOGIN_FAILED';
export const INIT_PLUGINS = 'VNT/App/INIT_PLUGINS';
export const INIT_PLUGINS_SUCCESS = 'VNT/App/INIT_PLUGINS_SUCCESS';
export const CHECK_PLUGINS_SUCCESS = 'VNT/App/CHECK_PLUGINS_SUCCESS';
export const MENU_TOGGLE = 'VNT/App/MENU_TOGGLE';
export const REQUEST_PASSWORD_RECOVERY = 'VNT/App/REQUEST_PASSWORD_RECOVERY';
export const PASSWORD_RECOVERY = 'VNT/App/PASSWORD_RECOVERY';
export const DELETE_HELP = 'VNT/App/DELETE_HELP';

export function deleteHelp(payload) {
  return {
    type: DELETE_HELP,
    payload,
  };
}


export function login(username, password) {
  return {
    type: LOGIN,
    username,
    password
  };
}

export function requestPasswordRecovery(email, redirect = true) {
  return {
    type: REQUEST_PASSWORD_RECOVERY,
    email,
    redirect
  };
}

export function passwordRecovery(password, recovery_code) {
  return {
    type: PASSWORD_RECOVERY,
    password,
    recovery_code,
  };
}

export function loading(value) {
  return {
    type: LOADING,
    value,
  };
}

export function loginSuccess(profile) {
  return {
    type: LOGIN_SUCCESS,
    profile
  };
}

export function loginFailed(error) {
  return {
    type: LOGIN_FAILED,
    error
  };
}

export function logout() {
  return {
    type: LOG_OUT,
  };
}

/**
 * get Api key for access to API
 *
 * @return {object} An action object with a type of GET_TOKEN
 */
export function getApiKey(payload) {
  return {
    type: GET_TOKEN,
    payload,
  };
}

/**
 * Dispatched when the token is loaded by the request saga
 *
 * @param  {string} Api key
 *
 * @return {object} Session token (api key)
 */
export function getApiKeySuccess(token) {
  return {
    type: GET_TOKEN_SUCCESS,
    token,
  };
}

/**
 * Dispatched when the refreshed token is loaded by the request saga
 *
 * @param  {string} Api key
 *
 * @return {object} Session token (api key)
 */
export function getRefreshedApiKeySuccess(token) {
  return {
    type: GET_REFRESHED_TOKEN_SUCCESS,
    token,
  };
}

/**
 * Dispatched when loading the token fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of GET_TOKEN_ERROR passing the error
 */
export function getApiKeyError(error) {
  return {
    type: GET_TOKEN_ERROR,
    error,
  };
}


/**
 * Dispatched to load user profile
 *
 *
 * @return {object} An action object with a type of GET_CUSTOMERS
 */
export function callProfile() {
  return {
    type: GET_PROFILE,
  };
}

export function callProfileSuccess(payload) {
  return {
    type: GET_PROFILE_SUCCESS,
    payload,
  };
}

export function callProfileError(error) {
  return {
    type: GET_PROFILE_ERROR,
    error,
  };
}

export function apiInfoSuccess(info) {
  return {
    type: API_INFO_SUCCESS,
    info,
  };
}

export function manageLogin(error) {
  return {
    type: INVALID_ACCESS,
    error,
  };
}

export function initPlugins() {
  return {
    type: INIT_PLUGINS,
  };
}

export function initPluginsSuccess(plugins) {
  return {
    type: INIT_PLUGINS_SUCCESS,
    plugins,
  };
}

export function checkPluginsSuccess(plugins) {
  return {
    type: CHECK_PLUGINS_SUCCESS,
    plugins,
  };
}

export function toggleExpandSubMenu(menu) {
  return {
    type: MENU_TOGGLE,
    menu: menu
  };
}



// WEBPACK FOOTER //
// ./src/containers/App/actions.js